<template>
  <f7-page
    :theme-dark="dark"
    id="settings-terms">

    <f7-navbar
      back-link
      :theme-dark="dark"
      :title="t('termsTitle')">
    </f7-navbar>

    <f7-block :class="{ 'text-align-center': loading }">
      <f7-preloader v-if="loading" />
      <div
        v-if="text"
        v-html="text" />
      <SystemInfo
        v-if="err"
        icon="error" >
        {{ err }}
      </SystemInfo>
    </f7-block>

  </f7-page>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SettingsTerms',
  data () {
    return {
      loading: false,
      text: null,
      err: null
    }
  },
  computed: {
    ...mapGetters({
      setting: 'global/setting'
    }),
    gtu () {
      return this.setting('gtu')
    }
  },
  methods: {
    getGtu (version) {
      this.loading = true
      this.$db.gtu.get({ version })
        .then(doc => {
          this.text = doc.text
          this.loading = false
        })
        .catch(err => {
          this.err = err.message
          this.loading = false
        })
    }
  },
  created () {
    this.getGtu(this.gtu)
  }
}
</script>

<docs>
```js
<SettingsTerms />
```
</docs>
